import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

// Shown full-screen while a snapshot restore holds the workspace lock. The
// AuthContext listener on users/{companyName}/_meta/restore_lock moves
// restoreStatus off 'active' when the lock clears, which unmounts this page.
export default function Restoring() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
        textAlign: 'center',
      }}
    >
      <CircularProgress />
      <Typography variant="h6">Restoring your workspace…</Typography>
      <Typography variant="body2" color="text.secondary">
        Your data is being restored from a backup. The platform is temporarily
        unavailable and will return automatically when the restore completes.
      </Typography>
    </Box>
  );
}
